module.exports = __webpack_public_path__ + "img/facebook_sign_in.ffc6b9ff.svg";